import { useCallback } from "react";
import { Box } from "@mantine/core";
import { useForm } from "@mantine/form";
import { TFunction } from "i18next";

import { AppUtils } from "utils";

import Button from '../../button/standard';
import TextArea from '../../input/area';

interface CommentInputProps {
  loading: boolean;
  onSubmit: (comment: string) => void;
  t: TFunction;
}

const CommentInput = ({ onSubmit, loading, t }: CommentInputProps) => {

  const form = useForm({
    initialValues: {
      comment: ''
    },
    validate: {
      comment: (value: string) => AppUtils.isEmpty(value) ? t('error.required') : null
    }
  });

  const onSubmitWrapper = useCallback(() => {
    onSubmit(form.getTransformedValues().comment);
    form.reset();

  }, [form])

  return (
    <Box>
      <TextArea
        rows={10}
        key={form.key('comment')}
        {...form.getInputProps('comment')}
        placeholder={t('comments.placeholder')}
        disabled={loading}
        style={{ flexGrow: 1 }}
      />
      <Button
        mt={'md'}
        disabled={loading || !form.isValid()}
        loading={loading}
        onClick={onSubmitWrapper}
        fullWidth={true}
      >
        {t('action.post')}
      </Button>
    </Box>
  )
}

export default CommentInput;